// Fix U (2026-10-13): textos, formatos y estilos compartidos de la academia.
const USD = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });

export const money = (n) => USD.format(Number(n) || 0).replace(".00", "");

// "2026-11-14" -> "14/11/2026" (sin pasar por Date: no se corre de dia por la zona horaria)
export function fmtDate(iso) {
  if (!iso) return "";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}

// Las fechas de registro (created_at, at) vienen en UTC sin zona: se marcan como UTC.
export function fmtDateTime(value) {
  if (!value) return "";
  const str = String(value);
  const dt = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(str) ? str : `${str}Z`);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function editionLabel(e) {
  if (!e) return "";
  let s = fmtDate(e.start_date);
  if (e.end_date && e.end_date !== e.start_date) s += ` al ${fmtDate(e.end_date)}`;
  if (e.start_time) s += ` · ${e.start_time}${e.end_time ? ` a ${e.end_time}` : ""}`;
  return s;
}

export const LEAD_STAGES = [
  { key: "new", label: "Nuevo", cls: "bg-[#EEF1F4] text-[#4B5B6B]" },
  { key: "contacted", label: "Contactado", cls: "bg-[#E4EEF2] text-[#3F6E80]" },
  { key: "interested", label: "Interesado", cls: "bg-[#F4ECDD] text-[#8A6A2F]" },
  { key: "enrolled", label: "Inscripción enviada", cls: "bg-[#EDE6F4] text-[#6A4F8A]" },
  { key: "reserved", label: "Reservó", cls: "bg-[#E3EDE1] text-[#5B7A54]" },
  { key: "lost", label: "Perdido", cls: "bg-[#F4E1E1] text-[#A34B49]" },
];
export const LEAD_STAGE = Object.fromEntries(LEAD_STAGES.map((s) => [s.key, s]));

export const PAYMENT_METHODS = [
  { key: "cash", label: "Efectivo" },
  { key: "card", label: "Tarjeta" },
  { key: "zelle", label: "Zelle" },
  { key: "cherry", label: "Cherry" },
  { key: "transfer", label: "Transferencia" },
  { key: "other", label: "Otro" },
];
export const PAYMENT_METHOD_LABELS = { ...Object.fromEntries(PAYMENT_METHODS.map((m) => [m.key, m.label])), credit: "Saldo a favor" };

export const ENROLLMENT_STATUS = {
  pending: { label: "Pendiente", cls: "bg-[#F4ECDD] text-[#8A6A2F]" },
  confirmed: { label: "Confirmada", cls: "bg-[#E3EDE1] text-[#5B7A54]" },
  attended: { label: "Asistió", cls: "bg-[#E4EEF2] text-[#3F6E80]" },
  no_show: { label: "No asistió", cls: "bg-[#F4E1E1] text-[#A34B49]" },
  expired: { label: "Reserva vencida", cls: "bg-[#EEF1F4] text-[#4B5B6B]" },
  cancelled: { label: "Cancelada", cls: "bg-[#EEF1F4] text-[#4B5B6B]" },
  completed: { label: "Completada", cls: "bg-[#E3EDE1] text-[#5B7A54]" },
  transferred: { label: "Pasada a otro curso", cls: "bg-[#EEF1F4] text-[#4B5B6B]" },
};

export const EDITION_STATUS = { open: "Abierta", closed: "Cerrada", done: "Terminada", cancelled: "Cancelada" };

// Fix D (2026-10-18): estado de cada practica (las anteriores a D no tienen status)
export const PRACTICE_STATUS = {
  scheduled: { label: "Agendada", cls: "bg-[#F4ECDD] text-[#8A6A2F]" },
  attended: { label: "Hizo la práctica", cls: "bg-[#E3EDE1] text-[#5B7A54]" },
  absent: { label: "Faltó", cls: "bg-[#F4E1E1] text-[#A34B49]" },
};
export const practiceStatus = (p) => p.status || (p.attended ? "attended" : "absent");

export function waLink(phone, text) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return null;
  const full = digits.length === 10 ? `1${digits}` : digits; // numero de EE.UU. sin el 1
  return `https://wa.me/${full}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}

export const selectCls = "flex h-9 w-full rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:opacity-50";
export const btnBrand = "bg-brand hover:bg-brand-hover text-white";
